import React from 'react';
import styles from '@dazn/lp-web/src/components/Header/header.module.css';
import {DaznChapterEnum} from '@dazn/lp-web/src/types/dazn/DaznChapterEnum';
import DaznIcon from '@dazn/lp-web/src/components/Header/DaznIcon';
import {isNativeSession, navigateToDifferentChapterUrl} from '@dazn/lp-web/src/utils';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events/index';
import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import {useLandingPagesContext} from '@dazn/lp-web/src/contexts/LandingPageContext';
import {checkIfShowLPExploreButtonEnabled} from '@dazn/lp-web/src/features/checkIfFreemiumFeatureEnabled';
import {
    exploreChapterData,
    exploreChapterPath,
    signinChapterData,
    signinChapterPath
} from './Utils/features';
import isQueryParamTrue from '../../utils/isQueryparamTrue';
import classNames from 'classnames';
import {
    isBoxingBetaPageAfterAuth,
    showActionButton
} from '../../utils/boxingBeta';
import {externalServices} from '../../constants/resourceStrings.constants';
import {checkHideHeaderEnabled} from '../../features/checkHideHeaderEnabled';

interface HeaderProps {
    hideExploreButton: boolean;
    pageError: string | undefined;
}

const Header: React.FC<HeaderProps> = ({hideExploreButton, pageError}) => {
    const {signUpchapterPath, signUpchapterData} = externalServices.roblox;

    const headerBtnProp = isBoxingBetaPageAfterAuth()
        ? 'landingpages_web_header_button_signUp'
        : 'landingpages_web_header_button_signIn';

    const stringValue =
        window.dazn?.resourceStringsData?.Strings[headerBtnProp];

    const exploreButtonStringValue =
        window.dazn?.resourceStringsData?.Strings[
            'landingpages_web_header_explore_button'
        ];
    const {pagePromoCode} = useLandingPagesContext();

    const handleClick = () => {
        const navigationData = isNativeSession() ? {
            chapterName: DaznChapterEnum.Auth,
            chapterPath: 'account/content/dazn/signup',
            chapterData: {
                native3ppSignin: true
            }
        } : isBoxingBetaPageAfterAuth() 
            ? {
                  chapterName: DaznChapterEnum.Auth,
                  chapterPath: signUpchapterPath,
                  chapterData: signUpchapterData
              }
            : {
                  chapterName: DaznChapterEnum.SignIn,
                  chapterPath: signinChapterPath ?? '/signin',
                  chapterData: {
                      ...signinChapterData(),
                      ...(pagePromoCode ? {promoCode: pagePromoCode} : {}),
                      ...(window.location.href.includes('nfl') ||
                      window.location.href.includes('gamepass') ||
                      window.location.href.includes('lg-')
                          ? {isNfl: true}
                          : {})
                  }
              };

        triggerElementClick({
            section: elementClickEventTypes.HEADER,
            itemId: 'landingpages_web_header_button_signIn',
            resourceString: stringValue || ''
        });

        navigateToDifferentChapterUrl(navigationData);
    };

    const handleExploreButtonClick = () => {
        triggerElementClick({
            section: elementClickEventTypes.HEADER,
            itemId: 'landingpages_web_header_explore_button',
            resourceString: exploreButtonStringValue || ''
        });

        navigateToDifferentChapterUrl({
            chapterName: DaznChapterEnum.Catalog,
            chapterPath: exploreChapterPath ?? '/home',
            chapterData: {
                ...exploreChapterData()
            }
        });
    };

    return checkHideHeaderEnabled() ? null : (
        <header className={styles.header}>
            <DaznIcon />
            {pageError && <h2 className={styles.error}>{pageError}</h2>}
            <div className={styles.buttonsContainer}>
                {checkIfShowLPExploreButtonEnabled() &&
                    !hideExploreButton &&
                    (isQueryParamTrue('seo') ? (
                        <a
                            href={'/home'}
                            className={classNames(
                                styles.buttonPrimary,
                                'seoButton'
                            )}
                        >
                            {exploreButtonStringValue}
                        </a>
                    ) : (
                        <button
                            className={styles.buttonPrimary}
                            onClick={() => handleExploreButtonClick()}
                        >
                            {exploreButtonStringValue}
                        </button>
                    ))}
                {showActionButton(pageError) && (
                    <>
                        {isQueryParamTrue('seo') ? (
                            <a
                                href={'/signin'}
                                className={classNames(
                                    styles.buttonSecondary,
                                    'seoButton'
                                )}
                            >
                                {stringValue}
                            </a>
                        ) : (
                            <button
                                className={styles.buttonSecondary}
                                onClick={() => handleClick()}
                            >
                                {stringValue}
                            </button>
                        )}
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;
